<div class="bottom-sheet">
  <div class="bottom-sheet__wrapper">
    <div class="bottom-sheet__header">
      <h3 class="bottom-sheet__title">{{ title }}</h3>
      <button mat-icon-button (click)="emitClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="bottom-sheet__subtitle" *ngIf="subtitle">{{ subtitle }}</div>
    <div class="bottom-sheet__content">
      <ng-content></ng-content>
    </div>
  </div>
  <div class="bottom-sheet__actions">
    <ng-content select="[slot='actions']"></ng-content>
  </div>
</div>
